<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row row--primary">
  <div class="col-12 text-center mb-2 lottie-animation">
    <ng-lottie [options]="options" />
  </div>
  <div class="col-12 text-center mb-2">
    <h1 class="zero-text p-huge-med">
      {{ 'mydepot.trading.order-success.hint' | transloco }}
    </h1>
  </div>
  <trade-secure-tan-hint />
</div>
@if (isReady && quantity >= 1) {
  <trade-protect-order
    data-zid="trade-protect-order"
    [asset]="tradeService.asset$ | async"
    [quantity]="(tradeService.cache$ | async)?.form?.get('quantityForm').get('quantity').value"
    [execType]="(tradeService.cache$ | async)?.form?.get('execType').value"
    [direction]="(tradeService.cache$ | async)?.form?.get('direction').value"
    [quote]="tradeService.quote$ | async"
    (protectOrder)="onProtectOrder($event)"
    (furtherOrder)="goInit.emit()"
  />
}
@if (tradeService.asset$ | async; as asset) {
  <trade-knowledge-and-experience [isins]="[asset.isin]" />
}
